import React, { PropsWithChildren } from "react";

import Verified2Icon from "public/icons/verified-2.svg";

import { TypographyProps } from "@mui/material";

import { TruncatedWithTooltip } from "@/lib/truncate/TruncatedWithTooltip";
import { WithClassName } from "@/models/utils.models";

import { SvgIcon } from "../svg-icon/SvgIcon";
import { Tooltip } from "../tooltip/Tooltip";

type PropTypes = PropsWithChildren &
  WithClassName & {
    iconWidth?: number;
    iconHeight?: number;
    iconClassName?: string;
    typographyComponent?: TypographyProps["component"];
    depsArray?: unknown[];
  };

export const LadyNameVerified: React.FC<PropTypes> = ({
  children,
  className,
  iconWidth,
  iconHeight,
  iconClassName,
  typographyComponent = "h2",
  depsArray = [],
}) => {
  return (
    <div className="flex items-center gap-1">
      <TruncatedWithTooltip
        component={typographyComponent}
        className={className}
        depsArray={depsArray}
        data-testid="ladyName"
      >
        {children}
      </TruncatedWithTooltip>
      <Tooltip title="Verified">
        <SvgIcon
          width={iconWidth || 24}
          height={iconHeight || 24}
          className={iconClassName}
        >
          <Verified2Icon />
        </SvgIcon>
      </Tooltip>
    </div>
  );
};
